import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
export function ProductSection() {
  const features = ['Los 5 pilares del colapso digestivo moderno', 'El principio del terreno explicado paso a paso', 'Eje intestino-cerebro — por qué tu panza controla tu estado de ánimo', 'Plan intensivo 14 días en 4 etapas', 'Regla 80/20 digestiva', 'Mini-reset de 3 días para mantenimiento', '100% aplicable sin experiencia previa'];
  const bonuses = [{
    num: '01',
    title: 'Lista de Compras Inteligente',
    desc: 'Cómo comprar con intención y no sabotear el proceso antes de empezar. Incluye cómo leer etiquetas y 7 nombres del azúcar.',
    result: 'Nunca más saboteás el proceso en el supermercado',
    value: '$8.000'
  }, {
    num: '02',
    title: 'Plan de Comidas 7 y 14 Días',
    desc: 'Menú completo día a día. Todo decidido de antemano. Cero fricción. Solo seguí el plan.',
    result: 'Eliminás la improvisación de raíz',
    value: '$10.000'
  }, {
    num: '03',
    title: '7 Errores que Arruinan tu Digestión',
    desc: 'Microcurso de 7 clases. Los sabotajes invisibles que frenan tu proceso sin que te des cuenta.',
    result: 'Identificás y eliminás lo que te estaba frenando',
    value: '$12.000'
  }, {
    num: '04',
    title: 'Recetario Digestivo',
    desc: '20 recetas antiinflamatorias. Desayunos en 5 min, almuerzos en 20 min, cenas en 10 min, snacks en 0 min.',
    result: 'Comés rico sin pensar ni improvisar',
    value: '$9.000'
  }, {
    num: '05',
    title: 'Reset Digestivo Avanzado',
    desc: 'El protocolo profundo para quienes quieren ir más allá. Desparasitación consciente y reconstrucción del sistema digestivo desde la raíz.',
    result: 'El siguiente nivel cuando ya dominás la base',
    value: '$12.000'
  }];
  const valueStack = [{
    name: 'Reset Digestivo (producto principal)',
    value: '$15.000'
  }, {
    name: 'Bono 1 — Lista de Compras Inteligente',
    value: '$8.000'
  }, {
    name: 'Bono 2 — Plan de Comidas 7 y 14 Días',
    value: '$10.000'
  }, {
    name: 'Bono 3 — 7 Errores que Arruinan tu Digestión',
    value: '$12.000'
  }, {
    name: 'Bono 4 — Recetario Digestivo',
    value: '$9.000'
  }, {
    name: 'Bono 5 — Reset Digestivo Avanzado',
    value: '$12.000'
  }];
  return <SectionWrapper className="bg-white" data-id="element-200">
      <div className="text-center mb-16" data-id="element-201">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 text-amber-600 mb-6" data-id="element-202">
          <EmojiEventsIcon fontSize="large" data-id="element-203" />
        </div>
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary mb-4" data-id="element-204">
          REINICIO INTERNO™ — KIT COMPLETO
        </h2>
        <p className="text-xl text-gray-600 font-medium" data-id="element-205">
          Reset Digestivo + 5 Bonos — Método META + MACA
        </p>
        <p className="text-lg text-primary font-bold mt-4" data-id="element-206">
          Todo resuelto. Todo incluido. Todo listo desde hoy.
        </p>
      </div>

      {/* Main Product */}
      <div className="bg-secondary rounded-3xl p-8 md:p-12 mb-16 border border-primary/10 shadow-lg" data-id="element-207">
        <div className="flex flex-col md:flex-row gap-10" data-id="element-208">
          <div className="w-full md:w-1/3" data-id="element-209">
            <div className="bg-primary text-white py-2 px-4 rounded-t-xl font-bold text-center uppercase tracking-wider text-sm" data-id="element-210">
              Producto Principal
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/3uSxY8YoAitkHSC1EgQk7y/Guia_de_desparasitacion_natural_(1).png" alt="Reset Digestivo" className="w-full h-auto rounded-b-xl shadow-md object-cover" data-id="element-211" />
          </div>
          <div className="w-full md:w-2/3" data-id="element-212">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-213">
              📘 RESET DIGESTIVO
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-214">
              El protocolo base de transformación digestiva. Método META + MACA
              completo en 4 fases:{' '}
              <strong data-id="element-215">Map → Eliminate → Create → Activate</strong>. No solo
              eliminás el problema — cambiás el terreno para que no vuelva.
            </p>
            <h4 className="font-bold text-primary mb-4 uppercase text-sm tracking-wider" data-id="element-216">
              Lo que obtenés:
            </h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-217">
              {features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-218">
                  <CheckCircleIcon className="text-green-500 mr-2 mt-0.5 flex-shrink-0" fontSize="small" data-id="element-219" />
                  <span className="text-sm text-gray-700 font-medium" data-id="element-220">
                    {feature}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      {/* Bonuses */}
      <div className="mb-16" data-id="element-221">
        <div className="text-center mb-10" data-id="element-222">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4" data-id="element-223">
            <CardGiftcardIcon data-id="element-224" />
          </div>
          <h3 className="font-serif text-3xl font-bold text-gray-900" data-id="element-225">
            LOS 5 BONOS — SIEMPRE INCLUIDOS
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-226">
          {bonuses.map((bono, i) => <div key={i} className="bg-white rounded-2xl p-6 border-2 border-primary/10 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-227">
              <div className="absolute top-0 right-0 bg-primary text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-228">
                BONO {bono.num}
              </div>
              <h4 className="text-lg font-bold text-gray-900 mt-4 mb-2 pr-12" data-id="element-229">
                {bono.title}
              </h4>
              <p className="text-sm text-gray-600 mb-4" data-id="element-230">{bono.desc}</p>
              <div className="bg-secondary p-3 rounded-lg mb-4" data-id="element-231">
                <p className="text-xs font-bold text-primary uppercase mb-1" data-id="element-232">
                  Qué resuelve:
                </p>
                <p className="text-sm text-gray-800 font-medium" data-id="element-233">
                  {bono.result}
                </p>
              </div>
              <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100" data-id="element-234">
                <span className="text-sm text-gray-400 line-through" data-id="element-235">
                  {bono.value}
                </span>
                <span className="font-bold text-green-600" data-id="element-236">GRATIS</span>
              </div>
            </div>)}
        </div>
      </div>

      {/* Value Stack */}
      <div className="max-w-2xl mx-auto bg-gray-900 text-white rounded-2xl overflow-hidden shadow-2xl" data-id="element-237">
        <div className="bg-primary py-4 text-center" data-id="element-238">
          <h3 className="font-serif text-2xl font-bold" data-id="element-239">
            💰 VALOR TOTAL DEL KIT
          </h3>
        </div>
        <div className="p-6 md:p-8" data-id="element-240">
          <ul className="space-y-4 mb-6" data-id="element-241">
            {valueStack.map((item, i) => <li key={i} className="flex justify-between items-center border-b border-gray-800 pb-3" data-id="element-242">
                <span className="text-gray-300 text-sm md:text-base" data-id="element-243">
                  {item.name}
                </span>
                <span className="font-medium" data-id="element-244">{item.value}</span>
              </li>)}
          </ul>
          <div className="flex justify-between items-center border-b-2 border-gray-700 pb-4 mb-6" data-id="element-245">
            <span className="text-lg font-bold" data-id="element-246">TOTAL REAL</span>
            <span className="text-xl font-bold line-through text-gray-400" data-id="element-247">
              $66.000
            </span>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center bg-white/10 p-4 rounded-xl" data-id="element-248">
            <span className="text-xl font-bold text-amber-400 mb-2 md:mb-0" data-id="element-249">
              HOY CON REINICIO INTERNO
            </span>
            <span className="text-3xl font-bold text-cta" data-id="element-250">$19.990</span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}